import { RuleResult } from 'types/DeclarationP5'

// Replaces C0710 in SK: the office of departure no longer makes the location of goods optional.
const NC007Validator = {
  validateLocationOfGoodsRequirement: ({
    additionalDeclarationType,
  }: {
    additionalDeclarationType: string
  }): RuleResult => (additionalDeclarationType === 'D' ? 'OPTIONAL' : 'REQUIRED'),
}

export default NC007Validator
